import { render, staticRenderFns } from "./ListCourseDetail.vue?vue&type=template&id=61d5fd72&scoped=true"
import script from "./ListCourseDetail.vue?vue&type=script&lang=js"
export * from "./ListCourseDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d5fd72",
  null
  
)

export default component.exports